import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 1;
  background-color: ${props => props.theme.color1};
  svg {
    margin-left: 10px;
    font-size: 22px;
  }
  .rightButtons {
    display: flex;
    align-items: center;
    color: white;
    div {
      background-color: #3b5998;
      padding: 6px 10px 6px 6px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: 600;
      outline: none;
      svg {
        margin-right: 5px;
      }
    }
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default withTheme(props => {
  const { theme } = props;
  return (
    <Root>
      <Content>
        <div></div>
        <div className="rightButtons"></div>
      </Content>
    </Root>
  );
});
